import { d as debounce } from './debounce-CFtxQv9K.js';

class EksterBar extends HTMLElement {
  connectedCallback() {
    this.openHandler = () => this.open();
    this.closeHandler = () => this.close();
    this.addEventListener('menu-blocks:open', this.openHandler);
    this.addEventListener('menu-blocks:close', this.closeHandler);

    this.lastScrollPosition = 0;
    this.handleScroll();

    window.addEventListener(
      'scroll',
      debounce(() => this.handleScroll(), 40)
    );
  }

  disconnectedCallback() {
    this.removeEventListener('menu-blocks:open', this.openHandler);
    this.removeEventListener('menu-blocks:close', this.closeHandler);
  }

  handleScroll() {
    if (this.classList.contains('open')) return;

    const currentScrollPosition = window.scrollY;
    const delta = Math.abs(currentScrollPosition - this.lastScrollPosition);

    // Only trigger if scroll amount is greater than delta threshold
    if (delta < 5) return;

    // Add appropriate class based on scroll down or up direction
    if (currentScrollPosition > this.lastScrollPosition && currentScrollPosition > 100) {
      this.classList.add('ekster-bar--hidden');
      document.body.classList.add('ekster-bar-not-visible');
    } else {
      this.classList.remove('ekster-bar--hidden');
      document.body.classList.remove('ekster-bar-not-visible');
    }

    // Store the current scroll position for next comparison
    this.lastScrollPosition = currentScrollPosition;
  }

  open() {
    this.classList.add('open');
    document.querySelector('[data-menu-blocks="backdrop"]')?.setAttribute('aria-hidden', 'false');
  }

  close() {
    this.classList.remove('open');
    document.querySelector('[data-menu-blocks="backdrop"]')?.setAttribute('aria-hidden', 'true');
  }
}

customElements.define('ekster-bar', EksterBar);
